// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__iUeKK","spin":"styles_spin__NEifY"};